import {catchError, EMPTY, Observable, Subject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {VacatureInfo} from '../models/vacature-info';
import {inject, Injectable} from '@angular/core';
import {MV_GATEWAY_URL} from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class VacatureService {

  private readonly httpClient = inject(HttpClient);
  private readonly gatewayUrl = inject(MV_GATEWAY_URL);

  vacatureInfo$: Observable<VacatureInfo>;
  serverError$ = new Subject<boolean>();

  constructor() {
    this.vacatureInfo$ = this.httpClient.get<VacatureInfo>(this.gatewayUrl + '/api/v1/vacatures')
        .pipe(
            catchError(() => {
              this.serverError$.next(true);
              return EMPTY;
            })
        );
  }

  getVacatureInfo$(): Observable<VacatureInfo> {
    return this.vacatureInfo$;
  }

  getServerError$(): Subject<boolean> {
    return this.serverError$;
  }

}
